import { Box, CircularProgress, useMediaQuery, useTheme } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { VaSettingsContext } from "contexts/VaSettings";
import { useContext, useEffect } from "react";

import { PAGE_VISITED } from "constants/trackingProps";
import { trackEvent } from "utils/tracking";

import EmailBoost from "./EmailBoost";
import VAPreviewPage from "./PreviewPage";
import GeneralSettings from "./VASettings/GeneralSettings";

export default function VA() {
  // Contexts
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { currentOrg } = useContext(OrganizationUserContext);

  const { loadData, bulkSendSetting, fetchLoading, setFetchLoading } =
    useContext(VaSettingsContext);

  useEffect(() => {
    trackEvent(PAGE_VISITED);
    if (currentOrg?.isVaUser) {
      loadData();
    } else {
      setFetchLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (fetchLoading) {
    return (
      <Box
        sx={{
          color: "#fff",
          zIndex: 9999,
          left: "50%",
          top: "50%",
          ml: "-20px",
          mt: "-20px",
          position: "absolute",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (currentOrg?.isVaUser && bulkSendSetting) {
    return (
      <>
        <GeneralSettings />
        {!isMobileScreen && <EmailBoost />}
      </>
    );
  }

  return <VAPreviewPage />;
}
